import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { client } from 'services/client';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { OUTSIDE_LINKS } from 'constants/paths';
import { appScheme } from 'utils/appScheme';
import { isString } from 'formik';

const Text = styled.p`
  text-align: center;
`;

const Link = styled.a`
  color: ${defaultTheme.colors.healthBlue};
`;

enum Options {
  PENDING,
  SUCCESS,
  ERROR,
  ALREADY_VERIFIED,
}

export const VerifyEmail: React.FC = () => {
  const { query } = useRouter();
  const [result, setResult] = useState<Options>(Options.PENDING);

  useEffect(() => {
    async function callEmailApi(token: string, userId: string) {
      try {
        const res: { message: string } = await client.post('verifyEmail', { token, userId }, false);
        if (res.message === 'Email has already been verified') {
          return setResult(Options.ALREADY_VERIFIED);
        }
        setResult(Options.SUCCESS);
      } catch (error) {
        setResult(Options.ERROR);
      }
    }

    if (isString(query.token)) {
      callEmailApi(query.token, isString(query.userId) ? query.userId : '');
    }
  }, [query.token]);

  return (
    <>
      {result === Options.SUCCESS && (
        <Text>
          Thanks! Your email has been verified.
          <br />
          <br />
          If you're on your mobile, click <Link href={`${appScheme}`}>here</Link> to re-open the
          vTail app.
        </Text>
      )}
      {result === Options.ALREADY_VERIFIED && <Text>This email has already been verified.</Text>}
      {result === Options.ERROR && (
        <Text>
          This token is invalid.
          <br />
          <br />
          Click <Link href={OUTSIDE_LINKS.supportEmail}>here</Link> to contact support.
        </Text>
      )}
    </>
  );
};
